/**
 * 品牌与文案集中定义
 *
 * 所有面向用户的品牌名称、Agent 显示名、通用文案统一在此维护，
 * 避免散落在代码各处的硬编码字符串导致不一致。
 *
 * Agent 显示名称从 REGISTERED_AGENTS 派生，确保单一数据源。
 */

import { REGISTERED_AGENTS } from '@/constants/agents'

// ======================== 平台品牌 ========================

export const PLATFORM_NAME = '望舒 AI'
export const PLATFORM_SHORT = '望舒'
export const PLATFORM_DESCRIPTION = 'AI 智能运营平台'
export const PLATFORM_COPYRIGHT = `© 2026 ${PLATFORM_SHORT} · ${PLATFORM_DESCRIPTION}`
/** 平台版本号；发版时与 git tag / 分支名同步更新 */
export const PLATFORM_VERSION = 'v1.0.5'

// ======================== Agent 显示名称（从 REGISTERED_AGENTS 派生） ========================

const _auto = REGISTERED_AGENTS.find(a => a.id === 'auto')!
export const COORDINATOR_AGENT = {
  name: _auto.label,
  shortLabel: _auto.shortLabel || _auto.label[0],
  icon: _auto.icon,
  color: _auto.color,
  role: _auto.role || 'AI 数字员工总协调',
  avatarUrl: _auto.avatarUrl || '/avatars/avatar-auto.png',
} as const

const _chatbi = REGISTERED_AGENTS.find(a => a.id === 'chatbi')!
export const DATA_ANALYST_AGENT = {
  name: _chatbi.label,
  shortLabel: _chatbi.shortLabel || _chatbi.label[0],
  icon: _chatbi.icon,
  color: _chatbi.color,
  role: _chatbi.role || '数据分析专家',
} as const

// ======================== 通用输出文案 ========================

export const GENERATED_BY_FOOTER = `由${PLATFORM_SHORT}自动生成`
